module.exports = __webpack_public_path__ + "img/GB.fbcd8b1e.svg";